import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import type { RecoveryVerificationDTO } from '@/types/auth/AuthDTOs';
import { sendRecoveryTwoFactorThunk } from '@/store/thunks/auth/sendRecoveryTwoFactorThunk';

export const verifyRecoveryOtpThunk = createAppAsyncThunk<
  RecoveryVerificationDTO,
  { emailAddress: string; code: string },
  { rejectValue: { message: string } }
>(
  'auth/verifyRecoveryOtp',
  withLoader(
    async({ emailAddress, code }, { dispatch, extra: { authService }, rejectWithValue }) => {
      try {
        const result = await authService.verifyRecoveryOtp({ emailAddress, code });
        await dispatch(sendRecoveryTwoFactorThunk({ recoveryToken: result.recoveryToken })).unwrap();
        return result;
      } catch (caught) {
        const message =
          caught instanceof Error ? caught.message : 'Failed to verify recovery OTP';
        return rejectWithValue({ message });
      }
    }
  )
);
